import Drawable from '../entities/Drawable.js';
import Sprite from './Sprite.js';
import { imageStore } from '../images.js';

export default class PokemonPreview extends Drawable {
    constructor({ pokemon = null, position = { x: 80, y: 24 } }) {
        super();
        this.position = position;
        this.pokemon = pokemon;
        this.visible = false;
        this.sprites = {};
        this.sprites.background = new Sprite({
            position: { x: this.position.x, y: this.position.y },
            image: imageStore.get('img/pokemon_preview_box.png'),
            visible: true,
        });
        this.sprites.pokemon = new Sprite({
            position: { x: 88, y: 32 },
            image: imageStore.get('img/spritesheets/pokemon_front_master_spritesheet_20_20.png'),
            isFromSpriteSheet: true,
            spriteSheetCols: 20,
            spriteSheetRows: 20,
            spriteIndex: 399,
            visible: true,
        });
    }

    show() {
        this.visible = true;
    }

    hide() {
        this.visible = false;
    }

    setPokemon(pokemon) {
        this.pokemon = pokemon;
    }

    draw() {
        if (!this.visible) {
            return;
        }
        if (this.pokemon === null) {
            console.warn('PokemonPreview: Pokemon is null');
            this.sprites.pokemon.spriteIndex = 399;
        } else {
            this.sprites.pokemon.spriteIndex = this.pokemon.id - 1;
        }
        this.sprites.background.draw();
        this.sprites.pokemon.draw();
    }
}
